import { render, staticRenderFns } from "./ConnectFiles.vue?vue&type=template&id=21e88b28"
import script from "./ConnectFiles.vue?vue&type=script&lang=js"
export * from "./ConnectFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports